export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"PlayKeyboard"},{"name":"viewport","content":"width=device-width, height=device-height, initial-scale=1, maximum-scale=1, target-densityDpi=device-dpi, user-scalable=no"},{"name":"description","content":"Get free Guardian Tales keyboard themes & stickers!"},{"property":"og:title","content":"Guardian Tales 4th Anniv. Collab"},{"property":"og:description","content":"Get free Guardian Tales keyboard themes & stickers!"},{"property":"og:image","content":"https://playkeyboard.s3.ap-northeast-2.amazonaws.com/event/gt-main-en.png"},{"property":"og:url","content":"https://webview.plkey.app/event/GUARDIAN_TALES"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"window.receiveUserToken = function (token) {\n    console.log(token);\n    localStorage.setItem(\"token\", token);\n};"}],"noscript":[],"title":"PlayKeyboard","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false